export default {"src":"/_next/static/media/logo7.121b0c42.svg","height":106,"width":150};